import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import CoachProgramsFilterBar from './CoachProgramsFilterBar'
import CoachProgramsList from './CoachProgramsList'
import { selectFilteredCategory, selectFiltersNumber } from '../../../reducers/groupProgramsReducer'
import NoPrograms from './EmptyProgramsList'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const CoachProgramsActiveTab = ({ fetchPrograms }) => {
  const { t } = useTranslation()
  const active = useSelector(state => state.groupPrograms.active)
  const filtersNumber = useSelector(state => selectFiltersNumber(state, active.filters))
  const filteredCategory = useSelector(state => selectFilteredCategory(state, active.filters?.categoryId))
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  return (
    <>
      <CoachProgramsFilterBar
        filters={active.filters}
        filteredCategory={filteredCategory}
        filtersNumber={filtersNumber}
        search={active.search}
        tab={'active'}
      />

      {
        active.programs.length > 0 ?
          <CoachProgramsList
            programs={active.programs}
            timezone={timezone}
            hasMore={active.hasMore}
            fetchPrograms={() => fetchPrograms(active, 'active')}
          />
          :
          active.hasMore === false ?
            (filtersNumber > 0 || active.search) ? (
              <NoPrograms
                title={t('programs.common.noProgramsFound')}
                subtitle={t('programs.groups.noMatchClearFilters')}/>
            ) : (
              <NoPrograms
                title={t('programs.groups.noActiveProgramsAvailable')}
                subtitle={t('programs.groups.createPrompt')}/>
            ) : (
              <Loader message={t('programs.groups.loadingPrograms')} />
            )
      }
    </>
  )
}

CoachProgramsActiveTab.propTypes = {
  fetchPrograms: PropTypes.func,
}

export default CoachProgramsActiveTab
